import {DestroyRef, inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {tap} from 'rxjs/operators';

import {EventBusPort} from '@platform/event-bus/domain/ports/event-bus.port';
import {SalesFacade} from '@features/sales/application/facades/sales.facade';
import {ServiceFinalizedEvent} from "@platform/event-bus/domain/events/service-finalized.event";

@Injectable({providedIn: 'root'})
export class SalesOnServiceClosedSubscriber {
  private readonly destroyRef = inject(DestroyRef);
  private readonly eventBus = inject(EventBusPort);
  private readonly sales = inject(SalesFacade);

  constructor() {
    this.eventBus
      .ofType(ServiceFinalizedEvent)
      .pipe(
        tap(() => {
          this.sales.clearSessionCart();
          this.sales.clearSessionOrders();
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
